import React, { useState, useEffect } from 'react';
import { Modal, Select } from '@monavate/ui-core';
import { useDispatch } from 'react-redux';
import { setIsOpenSelectClientModal } from '@/reduxStore/slices/rolesSlice';
import { Client } from '@/api/client';
import { onboardingApi } from '@/services/rest/apiInstances';
import { addNotification } from '@/reduxStore/slices/systemNotificationSlice';
import { clientViewService } from '@/helpers/clientViewService';

const SelectClientModal = ({ isOpen }: { isOpen: boolean }) => {
    const dispatch = useDispatch();

    const [selectedId, setSelectedId] = useState<string>('');
    const [clients, setClients] = useState<Client[]>([]);
    const [loading, setLoading] = useState(false);

    const transformClientsObjects = (clientArray: Client[]) => {
        return clientArray.map((c) => {
            return {
                label: c.name,
                value: c.id,
            };
        });
    };

    useEffect(() => {
        setLoading(true);
        onboardingApi
            .listClients()
            .then((response) => {
                const clientsFromResponse = response.data;
                setClients(clientsFromResponse);
            })
            .catch((error) => {
                dispatch(
                    addNotification({
                        message: 'Failed to fetch clients',
                        status: 'error',
                    }),
                );
                console.error('Error fetching clients:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const handleConfirm = () => {
        window.applyClientView();
        clientViewService.setSelectedClientId(selectedId);
        const fondClient = clients.find((c) => c.id === selectedId);
        if (fondClient?.name) {
            clientViewService.setSelectedClientName(fondClient.name);
        }
        dispatch(setIsOpenSelectClientModal({ isOpen: false }));

        setTimeout(() => {
            window.location.replace('/');
        }, 1);
    };

    const onCancelButtonClickHandler = () => {
        dispatch(setIsOpenSelectClientModal({ isOpen: false }));
    };

    return (
        <Modal
            width={456}
            open={isOpen}
            title="Select client"
            onClose={onCancelButtonClickHandler}
            onSubmit={handleConfirm}
            submitTitle="Confirm"
            disabledSubmit={!selectedId}
        >
            <Select
                label={'Select client'}
                required
                value={selectedId}
                options={transformClientsObjects(clients)}
                onChange={(client: string) => {
                    console.log('client ', client);
                    setSelectedId(client);
                }}
                showSearch
                data-test-id="select-product-type"
            />
        </Modal>
    );
};

export default SelectClientModal;
